'use strict';

var $ = require('jquery');
var _ = require('underscore');
var config = require('../../config');
var mediator = require('../../mediator');
var PreviewCarouselView = require('./PreviewCarouselView');
var DatasheetMainViewerView = require('./DatasheetMainViewerView');
import {parallelArrayEach} from '../../../utilities/uiLoopHelpers';
import { EnableAdobeAnalytics } from '../../../utilities/featureFlags';

let isFirstCall = true;

// Global functionality from the pdf conversion
function IDRViewer() {}
IDRViewer.prototype.goToPage = function(pageNumber) {
  mediator.trigger(config.events.datasheets.viewerGotoPage, pageNumber);
};
window.IDRViewer = window.IDRViewer || new IDRViewer();

var DatasheetViewerView = PreviewCarouselView.extend({

  events: {
    'click .ThumbnailCarousel-slide': 'onSlideClick'
  },

  initialize: function(options) {
    this.hashNavigation = !!options.hashNavigation;
    _.bindAll(this, 'extractDatasheetData', 'onCounterChange');
    DatasheetViewerView.__super__.initialize.apply(this, arguments);

    // Creates carousel for the main component
    this.addMainCarousel(this.$('.DatasheetCarousel'));

    // Add counter
    if (options.counter && options.counter.length) {
      var self = this;
      options.counter.each(function(i, el) {
        self.addCounter(el);
      });
    }

    // Creates carousel for desktop thumbnails
    var $desktopThumbnails = this.$('.DatasheetViewer-thumbnails');
    this.addThumbnailCarousel($desktopThumbnails.find('.ThumbnailCarousel-carousel'), {
      prevArrow: $desktopThumbnails.find('.Carousel-arrow--up'),
      nextArrow: $desktopThumbnails.find('.Carousel-arrow--down')
    });

    var $datasheetTitle = $('.DatasheetToolbar').data('title');
    if ($datasheetTitle) {
      var titleArr = $datasheetTitle.split('for');
    }
    if (titleArr) {
      $('.DatasheetCarousel').attr('aria-label', 'Datasheet PDF for ' + titleArr[1]);
    }

    this.listenTo(this.mainCarousel, 'change', this.updatePrevNextLink);
    mediator.on(config.events.datasheets.viewerGotoPage, this.onViewerGotoPage, this);

    this.datasheets = [];
    this.currentIndex = 0;

    // Datasheet pages data
    this.getDatasheetsData();

    if (this.hashNavigation) {
      // Navigate to slide got from hash value
      this.goToSlideFromHash();
    } else {
      // Navigate to the first
      this.goToSlide(0);
    }

    if (isFirstCall) {
      isFirstCall = false;
      // Track datasheet marketing event
      this.createDatasheetViewEvent();
      this.assignDatasheetDownloadHandler();
    }
  },

  collectDatasheetData: function() {
    let $datasheetTitle = $('.DatasheetDetail-title-text');
    if ($datasheetTitle.length) { // Datasheet detail page
      let $partDataEl = jQuery('.DatasheetDetail-title');
      let $datasheetDataEl = jQuery('.DatasheetToolbar');
      return {
        datasheetId: $datasheetDataEl.data('datasheetId'),
        datasheetName: $datasheetTitle.text(),
        datasheetUrl: $datasheetDataEl.data('datasheetDownloadUrl'),
        partId: $partDataEl.data('partId'),
        partName: $partDataEl.data('partName'),
        partUrl: $partDataEl.data('partUrl'),
        partCategory: $partDataEl.data('category'),
        manufacturer: $partDataEl.data('manufacturer')
      }   
    } else { // PDP
      let $partDataEl = $('.Product-Summary');
      let $partDataBomEl = $('.BomModal-opener');
      let $datasheetDataEl = $('.DatasheetToolbar');
      return {
        datasheetId: $datasheetDataEl.data('datasheetId'),
        datasheetName: $partDataEl.data('name'),
        datasheetUrl: $datasheetDataEl.data('datasheetDownloadUrl'),
        partId: $partDataBomEl.data('partId'),
        partName: $partDataEl.data('name'),
        partUrl: window.location.href,
        partCategory: $partDataEl.data('category'),
        manufacturer: $partDataEl.data('manufacturer')
      }
    }
  },

  createDatasheetViewEvent: function() {
    let data = this.collectDatasheetData();
    mediator.trigger(config.events.datasheets.view, {
      datasheetId: data.datasheetId,
      datasheetName: data.datasheetName,
      datasheetUrl: data.datasheetUrl,
      productId: data.partId,
      productName: data.partName,
      productUrl: data.partUrl,
      productCategory: data.partCategory,
      manufacturer: data.manufacturer,
      action: 'View'
    });
  },

  assignDatasheetDownloadHandler: function() {
    $('.DatasheetToolbar-downloadButton, .DatasheetViewer-downloadButton').click(() => {
      let data = this.collectDatasheetData();
      mediator.trigger(config.events.datasheets.download, {
        datasheetId: data.datasheetId,
        datasheetName: data.datasheetName,
        datasheetUrl: data.datasheetUrl,
        productId: data.partId,
        productName: data.partName,
        productUrl: data.partUrl,
        productCategory: data.partCategory,
        manufacturer: data.manufacturer,
        action: 'Download'
      });
      this.sendDatasheetInfoToAdobe();
    })
  },
 
  sendDatasheetInfoToAdobe: function () {
    if (EnableAdobeAnalytics.isEnabled()) {
      let element = $('.DatasheetDetail-title-text');
      let datasheetFamily;
      if (element.length > 0) {
        datasheetFamily = element.text().split(' ')[3];
      }
      window.adobeDataLayer.push({
        event: 'datasheet_interaction',
        dsCategory: undefined,
        dsAssociatedProducts: undefined,
        dsFamily: datasheetFamily || undefined
      });
    }
  },

  onSlideClick: function(e) {
    e.preventDefault();
  },

  initializeMainCarousel: function($mainCarousel) {
    this.mainCarousel = new DatasheetMainViewerView({
      el: $mainCarousel
    });
  },

  // Go to a slide from the hash value in the URL
  goToSlideFromHash: function() {
    // Find index from hash
    var index = _.findIndex(this.datasheets, {hashUrl: window.location.hash});

    // If no datasheet is found, select the first one
    if (index === -1) {
      index = 0;
    }

    this.goToSlide(index, true);
  },

  // Go to a slide by index
  goToSlide: function(index, doNotUpdateHash) {
    var datasheetData = this.datasheets[index];
    if (datasheetData) {
      // Switch main carousel to show the right slide
      this.mainCarousel.goToSlide(index, datasheetData.htmlUrl, datasheetData.imageUrl);

      // Update counter and hash url
      if (this.$counter) this.$counter.val(index + 1);

      if (this.hashNavigation && !doNotUpdateHash) {
        window.location.hash = datasheetData.hashUrl;
      }
    }
  },

  // Parse thumbnail carousel HTML code to get datasheet dats
  getDatasheetsData: function() {
    this.thumbnailCarousels[0].$('.ThumbnailCarousel-slide').each(this.extractDatasheetData);
  },

  // Extract a datasheet page data from HTML code
  extractDatasheetData: function(index, el) {
    var $el = $(el),
      $img = $el.find('.ThumbnailCarousel-slide-img');

    this.datasheets.push({
      hashUrl: $el.attr('href'),
      htmlUrl: $img.data('html'),
      imageUrl: $img.data('image')
    });
  },

  // Update prev and next arrow links
  updatePrevNextLink: function(prev, index) {
    this.currentIndex = index;
  },

  onViewerGotoPage: function(pageNumber) {
    if (_.isFinite(pageNumber)) {
      this.goToSlide(pageNumber > 0 ? pageNumber - 1 : 0);
    }
  }
}, {
  createDatasheetViewer: function($parent) {
    parallelArrayEach($parent.find('.DatasheetViewer'), (el) => {
      new DatasheetViewerView({
        el: el,
        counter: $('.DatasheetViewer-counter')
      });
    });
  }
});

module.exports = DatasheetViewerView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/DatasheetViewerView.js